import React from "react";
import { Helmet } from 'react-helmet';

function Education() {
  return (
    <div>

<Helmet>
        <title>سیستم یکپارچه مالی راینو - آموزش حسابداری</title>
        <meta name="description" content="آموزش‌های مختلف در مورد سیستمهای مالی ." />
        <meta name="keywords" content="آموزش, یادگیری, دوره‌ها , راینو" />
</Helmet>


<section className="py-4 bg-light title">
  <div className="container">
    <div className="row">
      <div className="col-md-4 my-auto">
        <h3 className="float-end">فیلم‌های آموزشی راینو</h3>
      </div>
    </div>
  </div>
</section>

<section className="section border-bottom">
  <div className="container">
    <h5 className="main-heading">فیلم‌های آموزشی راینو</h5>
    <div className="underline"></div>

    {/* ویدیوها */}
    <div className="video-container">
      <h6>بستن حساب ها در نرم افزار حسابداری راینو</h6>
      <div className="embed-responsive embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          title="بستن حساب ها در نرم افزار حسابداری راینو"
          allowFullScreen
          src="https://www.aparat.com/video/video/embed/videohash/z12j1fc/vt/frame"
        ></iframe>
      </div>

      <br />
      <br />

      <h6>انبار گردانی در نرم افزار حسابداری راینو</h6>
      <div className="embed-responsive embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          title="انبار گردانی"
          allowFullScreen
          src="https://www.aparat.com/video/video/embed/videohash/i807571/vt/frame"
        ></iframe>
      </div>
    </div>
  </div>
</section>

    </div>
  );
}

export default Education;
